import { type TravelWindow, staleRangeReason, toIsoDate } from '../propertySetup/propertySetupModel';

import type { BlackoutFormValues } from './types';

type SalesforceBlackout = App.OpportunityPage['black_out_dates'][number];

export type InvalidBlackout = {
  name: string;
  startDate: string | null;
  endDate: string | null;
};

export type PreviousBlackouts = {
  blackouts: Array<BlackoutFormValues>;
  invalid: Array<InvalidBlackout>;
  archived: number;
  outsideTravel: number;
  ended: number;
};

// The mirror doesn't sync Salesforce's Archive checkbox; archiving a blackout also renames it "ARCHIVED ...".
const ARCHIVED_NAME = /archiv/i;

export function reducePreviousBlackouts(
  blackOutDates: Array<SalesforceBlackout> = [],
  travelWindow: TravelWindow,
  today: string,
): PreviousBlackouts {
  const result: PreviousBlackouts = { blackouts: [], invalid: [], archived: 0, outsideTravel: 0, ended: 0 };
  blackOutDates.forEach((blackOutDate, index) => {
    const name = blackOutDate.name?.trim() || `Blackout ${index + 1}`;
    if (ARCHIVED_NAME.test(name)) {
      result.archived += 1;
      return;
    }
    const startDate = toIsoDate(blackOutDate.from__c);
    const endDate = toIsoDate(blackOutDate.to__c);
    if (!startDate || !endDate || startDate > endDate) {
      result.invalid.push({ name, startDate, endDate });
      return;
    }
    const staleReason = staleRangeReason({ startDate, endDate }, travelWindow, today);
    if (staleReason) {
      result[staleReason] += 1;
      return;
    }
    result.blackouts.push({ name, startDate, endDate });
  });
  return result;
}
